import { MutableTypedObject, TypedObject } from "@multiweb/types/react";
import { camelCaseToParamCase } from "./convert";

export type TransformKeysToParamCase = (objectToTransform: Record<string, string | number | boolean | undefined>, prefix?: string) => any;
/**
 * Transformuje camelCase keys objektu do param-case (využívá se společně s bemClassNames)
 * @param objectToTransform Objekt pro transformaci klíčů
 * @param prefix Předpona pro klíče
 */
export const transformKeysToParamCase: TransformKeysToParamCase = (objectToTransform: Record<string, string | number | boolean | undefined>, prefix = ""): any => (
    Object
        .entries(objectToTransform)
        .reduce((res, [key, value]) => ({
            ...res,
            [prefix + camelCaseToParamCase(key)]: value,
        }), {})
);

export type SplitObjectFunction<T> = (obj: TypedObject<T>, keyConditionFn: (id: string) => boolean) => [TypedObject<T>, TypedObject<T>];

/**
 * Rozdělí objekt na dva objekty podle podmínky aplikované na klíče.
 * @param obj Objekt pro rozdělení
 * @param keyConditionFn Funkce aplikovaná na klíče objektu určující jeho rozdělení
 * @return Pole s dvěmi objekty - první objekt obsahuje položky s klíči, které prochází podmínkovou funkcí. Druhý objekt obsahuje zbylé položky.
 */
export const splitObject = <T>(obj: TypedObject<T>, keyConditionFn: (id: string) => boolean): [TypedObject<T>, TypedObject<T>] => {
    const matchingItems: MutableTypedObject<T> = {};
    const restItems: MutableTypedObject<T> = {};
    Object.entries(obj).forEach(([id, item]) => {
        if (keyConditionFn(id)) {
            matchingItems[id] = item;
        } else {
            restItems[id] = item;
        }
    });
    return [matchingItems, restItems];
};
